import {
  faAngleDown as freeFasFaAngleDown,
  faAngleUp as freeFasFaAngleUp,
  faArrowLeft as freeFasFaArrowLeft,
  faAngleRight as freeFasFaAngleRight,
  faArrowDown as freeFasFaArrowDown,
  faArrowUp as freeFasFaArrowUp,
  faCalendar as freeFasFaCalendar,
  faCaretDown as freeFasFaCaretDown,
  faCaretUp as freeFasFaCaretUp,
  faCheck as freeFasFaCheck,
  faClock as freeFasFaClock,
  faEllipsisVertical as freeFasFaEllipsisVertical,
  faEye as freeFasFaEye,
  faHome as freeFasFaHome,
  faList as freeFasFaList,
  faMagnifyingGlass as freeFasFaMagnifyingGlass,
  faPlus as freeFasFaPlus,
  faRedo as freeFasFaRedo,
  faRemove as freeFasFaRemove,
  faStar as freeFasFaStar,
  faTriangleExclamation as freeFasFaTriangleExclamation,
  faUndo as freeFasFaUndo,
  faUserGroup as freeFasFaUserGroup,
  faTable as freeFasFaTable,
  faCheckCircle as freeFasFaCheckCircle,
  faX as freeFasFaX,
  faSpinner as freeFasFaSpinner,
  faChartSimple as freeFasFaChartSimple,
  faBuilding as freeFasFaBuilding,
  faAward as freeFasFaAward,
  faCompass as freeFasFaCompass,
  faChartPie as freeFasFaChartPie,
  faBook as freeFasFaBook,
  faUsersRectangle as freeFasFaUsersRectangle,
  faBriefcase as freeFasFaBriefcase,
  faLandmark as freeFasFaLandmark,
  faPiggyBank as freeFasFaPiggyBank,
  faGlobe as freeFasFaGlobe,
  faScaleBalanced as freeFasFaScaleBalanced,
  faPrint as freeFasFaPrint,
  faAsterisk as freeFasFaAsterisk
} from '@fortawesome/free-solid-svg-icons'

import {
  faArrowUpArrowDown as proFasFaArrowUpArrowDown,
  faStarSharp as proFasFaStarSharp,
  faCircleInfo as proFasFaCircleInfo,
  faInputText as proFasFaInputText,
  faSquareCheck as proFasFaSquareCheck,
  faSignature as proFasFaSignature,
  faPencil as proFasFaPencil,
  faXmarkLarge as proFasFaXmarkLarge,
  faCircleDollar as proFasFaCircleDollar,
  faSidebar as proFasFaSidebar,
  faWindowMaximize as proFasFaWindowMaximize,
  faText as proFasFaText,
  faLock as proFasFaLock,
  faUserCheck as proFasFaUserCheck
} from '@fortawesome/pro-solid-svg-icons'

import {
  faArrowProgress as proFarFaArrowProgress,
  faArrowUpRightFromSquare as proFarFaArrowUpRightFromSquare,
  faBallotCheck as proFarFaBallotCheck,
  faCalendarDay as proFarFaCalendarDay,
  faEdit as proFarFaEdit,
  faEnvelope as proFarFaEnvelope,
  faEye as proFarFaEye,
  faGear as proFarFaGear,
  faHammer as proFarFaHammer,
  faHome as proFarFaHome,
  faIdCard as proFarFaIdCard,
  faLink as proFarFaLink,
  faMicroscope as proFarFaMicroscope,
  faPaperPlaneTop as proFarFaPaperPlaneTop,
  faSend as proFarFaSend,
  faUnlink as proFarFaUnlink,
  faUpload as proFarFaUpload,
  faUsersViewfinder as proFarFaUsersViewfinder,
  faChartScatterBubble as proFarFaChartScatterBubble,
  faFolderOpen as proFarFaFolderOpen,
  faDownload as proFarFaDownload,
  faCircleEnvelope as proFarFaCircleEnvelope,
  faTrash as proFarFaTrash,
  faTrashCan as proFarFaTrashCan,
  faEnvelopeCircleCheck as proFarFaEnvelopeCircleCheck,
  faChartLine as proFarFaChartLine,
  faChevronDown as proFarFaChevronDown,
  faInputNumeric as proFarFaInputNumeric,
  faFileSignature as proFarFaFileSignature,
  faPen as proFarFaPen,
  faMagnifyingGlassPlus as proFarFaMagnifyingGlassPlus,
  faMagnifyingGlassMinus as proFarFaMagnifyingGlassMinus,
  faArrowDownToLine as proFarFaArrowDownToLine,
  faCirclePlus as proFarFaCirclePlus,
  faFilter as proFarFaFilter,
  faSquareDashedCirclePlus as proFarFaSquareDashedCirclePlus,
  faCopy as proFarFaCopy,
  faEyeSlash as proFarFaEyeSlash,
  faLock as proFarFaLock
} from '@fortawesome/pro-regular-svg-icons'

import {
  faAddressCard as proFadFaAddressCard,
  faBallotCheck as proFadFaBallotCheck,
  faChartLine as proFadFaChartLine,
  faEnvelopeCircleCheck as proFadFaEnvelopeCircleCheck,
  faEyeSlash as proFadFaEyeSlash,
  faIdCard as proFadFaIdCard,
  faInbox as proFadFaInbox,
  faMessageQuestion as proFadFaMessageQuestion,
  faPeopleGroup as proFadFaPeopleGroup,
  faTable as proFadFaTable,
  faArrowUpArrowDown as proFadFaArrowUpArrowDown,
  faSquareDashedCirclePlus as proFadFaSquareDashedCirclePlus
} from '@fortawesome/pro-duotone-svg-icons'

export default {freeFasFaAngleDown, freeFasFaAngleUp, freeFasFaArrowLeft, freeFasFaAngleRight, freeFasFaArrowDown, freeFasFaArrowUp, freeFasFaCalendar, freeFasFaCaretDown, freeFasFaCaretUp, freeFasFaCheck, freeFasFaClock, freeFasFaEllipsisVertical, freeFasFaEye, freeFasFaHome, freeFasFaList, freeFasFaMagnifyingGlass, freeFasFaPlus, freeFasFaRedo, freeFasFaRemove, freeFasFaStar, freeFasFaTriangleExclamation, freeFasFaUndo, freeFasFaUserGroup, freeFasFaTable, freeFasFaCheckCircle, freeFasFaX, freeFasFaSpinner, freeFasFaChartSimple, freeFasFaBuilding, freeFasFaAward, freeFasFaCompass, freeFasFaChartPie, freeFasFaBook, freeFasFaUsersRectangle, freeFasFaBriefcase, freeFasFaLandmark, freeFasFaPiggyBank, freeFasFaGlobe, freeFasFaScaleBalanced, freeFasFaPrint, freeFasFaAsterisk, proFasFaArrowUpArrowDown, proFasFaStarSharp, proFasFaCircleInfo, proFasFaInputText, proFasFaSquareCheck, proFasFaSignature, proFasFaPencil, proFasFaXmarkLarge, proFasFaCircleDollar, proFasFaSidebar, proFasFaWindowMaximize, proFasFaText, proFasFaLock, proFasFaUserCheck, proFarFaArrowProgress, proFarFaArrowUpRightFromSquare, proFarFaBallotCheck, proFarFaCalendarDay, proFarFaEdit, proFarFaEnvelope, proFarFaEye, proFarFaGear, proFarFaHammer, proFarFaHome, proFarFaIdCard, proFarFaLink, proFarFaMicroscope, proFarFaPaperPlaneTop, proFarFaSend, proFarFaUnlink, proFarFaUpload, proFarFaUsersViewfinder, proFarFaChartScatterBubble, proFarFaFolderOpen, proFarFaDownload, proFarFaCircleEnvelope, proFarFaTrash, proFarFaTrashCan, proFarFaEnvelopeCircleCheck, proFarFaChartLine, proFarFaChevronDown, proFarFaInputNumeric, proFarFaFileSignature, proFarFaPen, proFarFaMagnifyingGlassPlus, proFarFaMagnifyingGlassMinus, proFarFaArrowDownToLine, proFarFaCirclePlus, proFarFaFilter, proFarFaSquareDashedCirclePlus, proFarFaCopy, proFarFaEyeSlash, proFarFaLock, proFadFaAddressCard, proFadFaBallotCheck, proFadFaChartLine, proFadFaEnvelopeCircleCheck, proFadFaEyeSlash, proFadFaIdCard, proFadFaInbox, proFadFaMessageQuestion, proFadFaPeopleGroup, proFadFaTable, proFadFaArrowUpArrowDown, proFadFaSquareDashedCirclePlus}